(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
class FooterComponent {
  constructor() {
    this.toggles = document.querySelectorAll('[data-footer-toggle]');
    this.init();
  }
  
  init() {
    // Initialize desktop: all menus expanded
    if (window.innerWidth >= 990) {
      this.toggles.forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'true');
      });
    }
    
    // Add click handlers for mobile
    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        // Only toggle on mobile
        if (window.innerWidth < 990) {
          this.toggleMenu(toggle);
        }
      });
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        // Desktop: expand all
        this.toggles.forEach(toggle => {
          toggle.setAttribute('aria-expanded', 'true');
          const column = toggle.closest('[data-footer-column]');
          const list = column?.querySelector('.footer__nav-list');
          if (list) {
            list.style.maxHeight = 'none';
          }
        });
      } else {
        // Mobile: collapse all
        this.toggles.forEach(toggle => {
          toggle.setAttribute('aria-expanded', 'false');
          const column = toggle.closest('[data-footer-column]');
          const list = column?.querySelector('.footer__nav-list');
          if (list) {
            list.style.maxHeight = '0';
          }
        });
      }
    });
  }
  
  toggleMenu(toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const column = toggle.closest('[data-footer-column]');
    const list = column?.querySelector('.footer__nav-list');
    
    if (!list) return;
    
    // Toggle aria-expanded
    toggle.setAttribute('aria-expanded', !isExpanded);
    
    // Toggle list visibility
    if (isExpanded) {
      list.style.maxHeight = '0';
      list.style.opacity = '0';
    } else {
      list.style.maxHeight = list.scrollHeight + 'px';
      list.style.opacity = '1';
    }
  }
}

const initNewsletterTracking = () => {
  const forms = document.querySelectorAll('[data-newsletter-form]');
  if (!forms.length) return;

  forms.forEach((form) => {
    if (form.dataset.analyticsBound === 'true') return;
    form.dataset.analyticsBound = 'true';

    const messageEl = form.querySelector('[data-newsletter-message]');
    const emailInput = form.querySelector('input[type="email"]');
    const formLocation = form.dataset.formLocation || 'footer';
    let lastStatus = '';

    const pushEvent = (status) => {
      if (!status || status === lastStatus) return;
      lastStatus = status;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'generate_lead',
        method: 'newsletter',
        form_location: formLocation,
        status
      });
    };

    form.addEventListener(
      'submit',
      () => {
        const email = emailInput ? emailInput.value.trim() : '';
        if (email && (!emailInput || emailInput.checkValidity())) {
          pushEvent('submitted');
        }
      },
      { capture: true }
    );

    if (messageEl) {
      const observer = new MutationObserver(() => {
        if (messageEl.classList.contains('footer__newsletter-status--success')) {
          pushEvent('success');
          return;
        }
        if (messageEl.classList.contains('footer__newsletter-status--error')) {
          pushEvent('error');
        }
      });
      observer.observe(messageEl, { attributes: true, attributeFilter: ['class'] });
    }
  });
};

const initFooter = () => {
  new FooterComponent();
  initNewsletterTracking();

  const syncRegionSelectorTheme = () => {
    const footerEl = document.querySelector('[data-footer]');
    const selectorEl = document.querySelector('.as-region-selector');
    if (!footerEl || !selectorEl) return;

    const footerStyles = getComputedStyle(footerEl);
    const bg = footerStyles.getPropertyValue('--color-background')?.trim();
    const fg = footerStyles.getPropertyValue('--color-foreground')?.trim();
    if (bg) selectorEl.style.backgroundColor = bg;
    if (fg) selectorEl.style.color = fg;

    const schemeClasses = Array.from(footerEl.classList).filter((cls) => cls.startsWith('color-'));
    const selectorSchemeClasses = Array.from(selectorEl.classList).filter((cls) => cls.startsWith('color-'));
    if (selectorSchemeClasses.length) {
      selectorEl.classList.remove(...selectorSchemeClasses);
    }
    if (schemeClasses.length) {
      selectorEl.classList.add(...schemeClasses);
      if (!selectorEl.classList.contains('color-scheme')) {
        selectorEl.classList.add('color-scheme');
      }
    }
  };

  syncRegionSelectorTheme();

  const root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;

  const targets = [];
  const footerEl = document.querySelector('[data-footer]');
  if (footerEl) {
    targets.push({ element: footerEl, key: 'footerInView' });
  }

  const faqEl = document.querySelector('[data-switch-target="cf-faq"], #cf-faq');
  if (faqEl) {
    targets.push({ element: faqEl, key: 'faqInView' });
  }

  const updatesEl = document.querySelector('[data-switch-target="cf-updates"], #cf-updates');
  if (updatesEl) {
    targets.push({ element: updatesEl, key: 'updatesInView' });
  }

  if (!targets.length) return;

  const keyMap = new Map(targets.map((target) => [target.element, target.key]));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const key = keyMap.get(entry.target);
        if (!key) return;
        if (entry.isIntersecting) {
          root.dataset[key] = 'true';
        } else {
          delete root.dataset[key];
        }
      });
    },
    { root: null, threshold: 0 }
  );

  targets.forEach((target) => observer.observe(target.element));
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooter);
} else {
  initFooter();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class HeaderComponent {
  constructor() {
    this.header = document.querySelector('[data-header]');
    this.mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
    this.mobileDrawer = document.querySelector('[data-mobile-drawer]');
    this.mobileBackdrop = document.querySelector('[data-mobile-backdrop]');
    this.mobileClose = document.querySelector('[data-mobile-close]');
    
    this.lastScrollY = window.scrollY;
    
    this.init();
  }
  
  init() {
    // Mobile menu handlers
    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', () => this.toggleMobileMenu());
    }
    
    if (this.mobileClose) {
      this.mobileClose.addEventListener('click', () => this.closeMobileMenu());
    }
    
    if (this.mobileBackdrop) {
      this.mobileBackdrop.addEventListener('click', () => this.closeMobileMenu());
    }
    
    // Escape key handler
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.mobileDrawer?.getAttribute('aria-hidden') === 'false') {
        this.closeMobileMenu();
      }
    });
    
    // Prevent body scroll when mobile menu is open
    if (this.mobileDrawer) {
      const observer = new MutationObserver(() => {
        const isOpen = this.mobileDrawer.getAttribute('aria-hidden') === 'false';
        document.body.style.overflow = isOpen ? 'hidden' : '';
        document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      });
      
      observer.observe(this.mobileDrawer, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
    
    // Scroll handler - always show on scroll up, hide on scroll down
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
  }
  
  toggleMobileMenu() {
    const isExpanded = this.mobileToggle.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }
  
  openMobileMenu() {
    if (!this.mobileDrawer) return;
    
    this.mobileToggle.setAttribute('aria-expanded', 'true');
    this.mobileDrawer.setAttribute('aria-hidden', 'false');
  }
  
  closeMobileMenu() {
    if (!this.mobileDrawer) return;
    
    this.mobileToggle.setAttribute('aria-expanded', 'false');
    this.mobileDrawer.setAttribute('aria-hidden', 'true');
  }
  
  handleScroll() {
    const currentScrollY = window.scrollY;
    
    // Add scrolled class for styling
    if (currentScrollY > 10) {
      this.header.classList.add('header--scrolled');
    } else {
      this.header.classList.remove('header--scrolled');
    }
    
    // Show on scroll up, hide on scroll down (when scrolled past 100px)
    if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
      // Scrolling down - hide header
      this.header.classList.add('header--hidden');
    } else {
      // Scrolling up - show header
      this.header.classList.remove('header--hidden');
    }
    
    this.lastScrollY = currentScrollY;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeaderComponent());
} else {
  new HeaderComponent();
}

  } catch(e) { console.error(e); }
})();
})();
